/**
 * Frases de evolução — narrativa calma e positiva sobre o progresso na escada.
 * Nunca punitiva: queda vira "tem oscilado", poucos dados vira "primeiras explorações".
 */
import { PASSO_ESCADA_LABEL, type DerivadosAlimento, type Oferta } from "../types";
import { MIN_OFERTAS_TENDENCIA } from "../domain";

export function fraseEvolucao(
  nome: string,
  ofertas: Oferta[],
  d: DerivadosAlimento,
): string {
  if (d.n_ofertas === 0) {
    return "ainda sem ofertas — quando começar, a evolução aparece aqui.";
  }

  const confirmadas = ofertas
    .filter((o) => o.confirmado)
    .sort((a, b) => a.data_hora.localeCompare(b.data_hora));
  const primeiro = confirmadas[0]?.passo_escada ?? d.passo_atual;

  if (d.n_ofertas < MIN_OFERTAS_TENDENCIA) {
    return `primeiras explorações de ${nome}. cada oferta conta 🌱`;
  }

  if (d.passo_maximo !== null && primeiro !== null && d.passo_maximo > primeiro) {
    return `saiu de "${PASSO_ESCADA_LABEL[primeiro]}" e já chegou a "${PASSO_ESCADA_LABEL[d.passo_maximo]}" 🎉`;
  }

  if (d.tendencia === "subindo") return "está avançando na escada — continue oferecendo 🌱";
  if (d.tendencia === "caindo") return "tem oscilado um pouco — sem pressão, faz parte do caminho.";
  if (d.passo_atual !== null) {
    return `mantendo "${PASSO_ESCADA_LABEL[d.passo_atual]}" com consistência.`;
  }
  return "seguindo o ritmo.";
}
